import { TableCell, TableRow, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { GroupedMaterial } from "../types";
import { useCraneDriver } from "../CraneDriverProvider";
import { createMaterialKey } from "../utils";

interface CraneRatioMaterialsRowProps {
  ratioMaterials: GroupedMaterial[];
}

export const CraneRatioMaterialsRow = ({
  ratioMaterials,
}: CraneRatioMaterialsRowProps) => {
  const { assignedLoads, basketMaterials } = useCraneDriver();
  const theme = useTheme();

  if (ratioMaterials.length === 0) return null;

  const materialNames = ratioMaterials.map((material) => material.materialName);

  return (
    <TableRow hover>
      <TableCell
        sx={{
          position: "sticky",
          left: 0,
          backgroundColor: "background.paper",
          fontSize: { xs: 12, md: 14, lg: 16 },
          fontWeight: "bold",
          minWidth: { xs: 56, md: 72, lg: 96 },
          maxWidth: 120,
          whiteSpace: "normal",
          wordBreak: "break-word",
        }}
      >
        {materialNames.join(":")}
      </TableCell>
      {assignedLoads.map((basket) => {
        const materialValues = ratioMaterials.map((material) => {
          const key = createMaterialKey(
            basket.load_basket_id,
            material.materialName,
            material.layerNumber
          );
          const targetMass =
            material.masses[assignedLoads.indexOf(basket)] ?? 0;
          const filledMass = basketMaterials[key]?.mass ?? targetMass;
          return filledMass;
        });

        return (
          <TableCell
            key={`ratio-values-${basket.load_basket_id}`}
            sx={{
              p: { xs: 1, md: 1.5, lg: 2 },
              minWidth: { xs: 280, md: 350, lg: 420 },
              maxWidth: { lg: 500 },
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 32, md: 40, lg: 48 },
                color: theme.palette.primary.main,
                fontWeight: "bold",
                lineHeight: 1.1,
              }}
            >
              {materialValues.join(":")}
            </Typography>
          </TableCell>
        );
      })}
    </TableRow>
  );
};
